"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icons = require("@blueprintjs/icons");
var _Core = require("../../Core");
var _stateDetails = require("../UtilizationChart/stateDetails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function SelectStates(_ref) {
  var onSelectItem = _ref.onSelectItem,
    selected = _ref.selected,
    width = _ref.width,
    activityDetails = _ref.activityDetails,
    selectedActivities = _ref.selectedActivities;
  var placeholder = selected.map(function (v) {
    return v.name;
  }).join(", ");
  return /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxList, {
    selected: selectedActivities,
    itemPredicate: function itemPredicate(query, item) {
      return item.name.toLowerCase().includes(query.toLowerCase());
    },
    renderItemText: function renderItemText(item) {
      return item.name;
    },
    groups: _stateDetails.stateDetails.reduce(function (stateDict, state) {
      stateDict[state.name] = function (item) {
        return item.state === state;
      };
      return stateDict;
    }, {}),
    items: activityDetails,
    getKey: function getKey(item) {
      return item.key;
    },
    placeholder: placeholder,
    small: true,
    minimal: true,
    multiple: true,
    rightIcon: _icons.IconNames.DOUBLE_CARET_VERTICAL,
    style: {
      width: width,
      justifyContent: "space-between"
    },
    toggle: true,
    onSelect: function onSelect(selectedItems) {
      return onSelectItem(selectedItems);
    }
  });
}
var _default = exports["default"] = SelectStates;